export function industry() {
    let accordionTriggerClass = ".industry-accordion .has-arrow";
    let $accordionItem = $(".industry-accordion .industry-item");
    let $mediaContainers = $(".industry-accordion .industry-item-media");
    let $slider = $(".industry-slider");
    let $sliderNav = $(".industry-slider-nav");
    let eventType = "click";
    let $win = $(window);

    let initSliders = function () {
        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            asNavFor: $sliderNav,
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            fade: true,
            speed: 1,
        });

        $sliderNav.slick({
            slidesToShow: 8,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            asNavFor: $slider,
            vertical: true,
            pauseOnHover: false,
            speed: 1,
        });

        if ($sliderNav.hasClass("slick-initialized")) {
            let showOptionLength = $sliderNav.slick("slickGetOption", "slidesToShow");
            let slidesLength = $sliderNav.find(".slick-slide").length;

            if (showOptionLength >= slidesLength) {
                $sliderNav.addClass("static");
            }
        }

        let $navItems = $sliderNav.find(".slick-slide");

        $navItems.on(eventType, function (e) {
            e.preventDefault();

            $sliderNav.slick("slickGoTo", $(this).attr("data-slick-index"));
        });
    };

    let closeAccordion = function () {
        $($accordionItem[1]).removeClass("show");

        for(let i = 0; i < $accordionItem.length; i++) {
            $($accordionItem[i]).removeClass("expanded");
            $($mediaContainers[i]).stop().slideUp(200);
        }
    };

    if ($("body").hasClass("no-touch")) {
        eventType = "mouseenter";
    }

    if ($win.width() >= 768) {
        initSliders();
    }

    $win.on("resize", function () {
        if ($win.width() >= 768 && !$slider.hasClass("slick-initialized")) {
            initSliders();
        }
    });

    $(document).on("click", accordionTriggerClass, function () {

        let $this = $(this);
        let filtersList = $this.siblings(".industry-item-media");

        if ($this.parent().hasClass("expanded")) {
            closeAccordion();
        } else {
            closeAccordion();
            $this.parent().addClass("expanded");
            filtersList.stop().slideDown(200);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/industry.js